import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService } from '../helper.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  userID: string;
  userList: [];
  userProfilePic: string;
  imgPlaceholder = './assets/images/noimage.png';

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService: HelperService,
    private cookieService: CookieService

  ) {



  }

  ngOnInit() {

    this.userID = this.helperService.studented_atob(this.helperService.getToken());

    if (this.userID != "") {

      let userData = {
        //token:this.helperService.studented_atob(this.helperService.getToken()),
        userID: this.helperService.studented_atob(this.helperService.getUserID())
      }

      this.apiService.userDetails(userData).subscribe((res: any) => {
        this.userList = res.data.getUserData.data;

        this.userProfilePic = res.data.getUserData.data.userProfilePic;


      }, async err => {

      })

    }


  }
  Home() {
    this.router.navigateByUrl(`search`);

  }
  SearchResults() {

  }
  login() {
    this.router.navigateByUrl(`login`);
  }
  courses() {
    this.router.navigateByUrl(`courses`);
  }
  assignment() {
    this.router.navigateByUrl(`assignment`);
  }
  howitworks() {
    this.router.navigateByUrl(`howitworks`);
  }
  gouser() {
    //this.router.navigateByUrl(`userprofile`);
    this.router.navigateByUrl(`dashboard`);
  }
  about() {
    this.router.navigateByUrl(`about-us`+'/');
  }
  faq() {
    this.router.navigateByUrl(`faq`);

    /*let url = "";
    this.apiService.getAppSettings().subscribe((resp: any) => {
      url = resp.help_faq_url;
      this.helperService.goToLink(url);
    });*/

  }
  contact() {
    this.router.navigateByUrl(`contactus`);
  }
  terms() {
    this.router.navigateByUrl(`terms`);
  }
  logout() {

    this.cookieService.deleteAll();
    this.router.navigateByUrl(`login`);
  }

}
